module.exports = __webpack_public_path__ + "img/16.fda5ef7b.png";